import React from 'react'
import { CardBody, Collapse } from 'reactstrap'
import { AssessSkillBar } from '..';
import forOwn from 'mout/object/forOwn'
export default function SkillGroup({
  report,
  title,
  color,
  parentReport,
  activeParentReport,
  setActiveParent,
  nodeFilter,
  navTo,
  query,
  props,
  skillReportLink,
  isCompare,
  isSwap
}) {
  

  let skillBars = []


  if (report) {
    report.forEach((node, n) => {
      const collapsed = (node.level != 1 && parentReport != activeParentReport && node.id != nodeFilter)
      skillBars.push(
        <Collapse isOpen={!collapsed} key={`AssessSkillBar${node.id}${n}`}>
          <AssessSkillBar
            nodeName={node.name}
            raw={node.raw} 
            possible={node.possible} 
            percent={Math.round(node.percent * 100) } 
            color={color} 
            margin={`ml-${(node.level - 1) * 2}`} 
            usedAsFilter={true} 
            nodeId={node.id} 
            isParent={node.id == parentReport}
            setActiveParent={setActiveParent}
            isActiveParent={node.id == activeParentReport}
            query={query}
            navTo={navTo}
            nodeFilter={nodeFilter}
            skillReportLink = {skillReportLink}
            percentCompare = { Math.round(node.percent1 * 100)}
            isCompare = {isCompare}
          />
        </Collapse>
      )
    })
  }

  return (
    <ul className='skill-group horizontal-bars type-2'>
      {skillBars}
    </ul>

  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessOverviewFilter/SkillGroup.js